import React, { createContext, useCallback, useMemo } from 'react'

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = React.useState([]);

  const addToCart = useCallback((item, quantity) => {
    const exist = cart.findIndex((cartItem) => cartItem.id === item.id);
    if (exist !== -1) {
      const newCart = [...cart];
      newCart[exist].quantity += quantity;
      setCart(newCart);
      return;
    }
    item.quantity = quantity;
    setCart([...cart, item]);
    
  }, [cart])

  const removeFromCart = useCallback((item) => {
    setCart(cart.filter((cartItem) => cartItem !== item));
    
  }, [cart])
 
  // Se till att detta objekt skapas
  const value = useMemo(() => ({
    cart,
    addToCart,
    removeFromCart,
    setCart,
    
  }), [cart, addToCart, removeFromCart]);

  // Här är den avgörande raden. Providern MÅSTE ha en `value`-prop.
  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export default CartContext;